const stringHelpersMixins = {


  methods: {
    toKebabCase(theString){
        return theString.replace(/[^a-zA-Z0-9]+/g, '-').toLowerCase()
    },
    toSnakeCase(theString){
      return theString.replace(/[^a-zA-Z0-9]+/g, '_').toLowerCase()
    },
    toCamelCase(theString){
      let camelCaseString = theString.replace(/[^a-zA-Z0-9]+(.)/g, (_, char) => char.toUpperCase())
      return camelCaseString.charAt(0).toLowerCase() + camelCaseString.slice(1)

    },
    firsLetterToLower(theString){
      return theString.charAt(0).toLowerCase() + theString.slice(1)

    },
    firsLetterToUpper(theString){
      return this.capitalizeFirstLetter(theString)
    },
    capitalizeFirstLetter(theString) {
      return theString.charAt(0).toUpperCase() + theString.slice(1)
    },
    toPascalCase(theString){
      let pascalCaseString = theString.replace(/[^a-zA-Z0-9]+(.)/g, (_, char) => char.toUpperCase())
      return pascalCaseString.charAt(0).toUpperCase() + pascalCaseString.slice(1)

    },
    stringIsEmptyNullOrWhiteSpace(theString){
      theString = theString.toString()
      if(theString == null || theString == '' || theString == ' '){
        return true
      }

      return false
    },

    removeSpecialCharacters(theString){
      return theString.replace(/[^a-zA-Z ]/g, "")
    },

    getSuitablePropertyNameFromString(theString, doItPascalCase = false)
    {
        //theString = theString.Replace(" ", "")

        theString = theString.replace("á", "a")
        theString = theString.replace("é", "e")
        theString = theString.replace("í", "i")
        theString = theString.replace("ó", "o")
        theString = theString.replace("ú", "u")

        theString = theString.replace("ñ", "gn")

        //theString = theString.Replace("-", "")
        //theString = theString.ToUpper()

        theString = (doItPascalCase)? this.toPascalCase(theString) : this.toCamelCase(theString)

        return this.removeSpecialCharacters(theString)
    },
    getSuitableFileNameFromString(theString, doItPascalCase = false)
    {
        //theString = theString.Replace(" ", "");

        theString = theString.replace("á", "a")
        theString = theString.replace("é", "e")
        theString = theString.replace("í", "i")
        theString = theString.replace("ó", "o")
        theString = theString.replace("ú", "u")

        theString = theString.replace("ñ", "gn")

        //theString = theString.Replace("-", "");
        //theString = theString.ToUpper();

        theString = (doItPascalCase)? this.toPascalCase(theString) : this.toCamelCase(theString)

        return theString.replace(/[^a-zA-Z0-9. ]/g, "")
    }

  },
  
}